// extracted by mini-css-extract-plugin
export default {"media":"Media_media__gqqDp","mediaData":"Media_mediaData__BTh1a","logo":"Media_logo__Xb2bz"};